<html>

<body>
  <form id="payForm" method="post" action="{{data.url}}">
    <input type="hidden" name="token_ws" value="{{data.token}}" />
  </form>
</body>

</html>